// Advance the last server epoch with monotonic elapsed time, not the device's
// wall clock. Foreground recovery/reconnection installs a fresh server anchor.
export class ServerClock {
  constructor({ monotonicNow = () => globalThis.performance.now() } = {}) {
    this.monotonicNow = monotonicNow;
    this.reset();
  }

  synchronize(serverNowMs) {
    if (!Number.isSafeInteger(serverNowMs) || serverNowMs <= 0 || serverNowMs > 8.64e15) {
      const error = new Error('服务器时间数据无效，请重新连接');
      error.code = 'SERVER_TIME_INVALID';
      throw error;
    }
    this.serverEpochMs = serverNowMs;
    this.anchorElapsedMs = this.monotonicNow();
  }

  now() {
    if (this.serverEpochMs === null) return null;
    return this.serverEpochMs + Math.max(0, this.monotonicNow() - this.anchorElapsedMs);
  }

  reset() {
    this.serverEpochMs = null;
    this.anchorElapsedMs = 0;
  }
}
